// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  buildingId: __t.string().name("building_id"),
  floor: __t.u32(),
  roomId: __t.string().name("room_id"),
  verified: __t.bool(),
  enteredAt: __t.timestamp().name("entered_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
